export default "__VITE_ASSET__BHlRZuoW__"